import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/ie11"; // For IE 11 support
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import momentLocalizer from "react-widgets-moment";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

// eslint-disable-next-line import-order-alphabetical/order
import moment from "moment";

moment.locale("en-gb");
momentLocalizer();

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
